import {
    scheduleActions,
    scheduleThunks as defaultThunks,
    scheduleSelectors as defaultSelectors,
    scheduleReducer,
} from './Schedule-slice';
import * as thunks from './Schedule-thunks';
import * as selectors from './Schedule-selectors';

const scheduleThunks = { ...defaultThunks, ...thunks };
const scheduleSelectors = { ...defaultSelectors, ...selectors };

export { scheduleSelectors, scheduleActions, scheduleThunks, scheduleReducer };
